import React, { FC, memo } from 'react';

import { StyleSheet } from 'react-native';

import { ILoyaltyTransaction } from '@rbi-ctg/menu';
import PointsIcon from 'components/icons/loyalty-points-icon';
import { Box, Typography } from 'components/ui';

interface IOrderPointsEarnedProps {
  loyaltyTransaction: ILoyaltyTransaction;
}

export const OrderPointsEarned: FC<IOrderPointsEarnedProps> = memo(({ loyaltyTransaction }) => {
  const pointsEarned = loyaltyTransaction.pointsEarned + loyaltyTransaction.bonusPointsEarned;

  return (
    <Box style={styles.container}>
      <Typography style={styles.bullet}>•</Typography>
      <PointsIcon width={21} height={21} />
      <Typography variant="bodyOne" style={styles.pointsText}>
        + {pointsEarned}
      </Typography>
    </Box>
  );
});

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  bullet: {
    marginHorizontal: 4,
  },
  pointsText: {
    marginLeft: 4,
  },
});
